const BattleCalc = require('../../BattleCalc');

const AStarSearch = function () {
  var _openList;
  var _closedList;

  var _currentNode;
  var _testNode;
  var _adjacentNodes;

  this.getPath = (startNode, destinationNode, battleState) => {
    if (!startNode || !destinationNode) {
      return [];
    }

    _openList = [];
    _closedList = [];

    _openList.push(startNode);
    startNode.g = 0;

    var attempts = 0;

    while (_openList.length > 0 && ++attempts < 1000) {
      _currentNode = getNodeWithLowestF(_openList);

      if (_currentNode === destinationNode) {
        // end case - we can build our path
        var path = buildPath(destinationNode, startNode);

        // clean up parent node assignments (as they may have created a circular reference)
        for (const tile of Object.values(battleState.allTiles)) {
          tile.parentNode = null;
        }

        return path;
      }

      // normal case - move _currentNode to the closed list...
      removeFromOpenList(_currentNode);
      _closedList.push(_currentNode);

      //...and process its neighbors
      _adjacentNodes = battleState.getAdjacentTiles(_currentNode);

      for (const _testNode of _adjacentNodes) {
        if (
          !_testNode ||
          (_testNode.occupied && _testNode.uid !== destinationNode.uid) ||
          isOnClosedList(_testNode)
        ) {
          // no need to process this node
          continue;
        }

        // g is the total cost it took for us to get from the startNode to our _testNode
        var g =
          _currentNode.g + BattleCalc.boardDistance(_currentNode, _testNode);
        var best_g = false;

        if (!isOnOpenList(_testNode)) {
          // first time we've evaluated this node
          best_g = true;
          _testNode.h = BattleCalc.boardDistance(_testNode, destinationNode);
          _openList.push(_testNode);
        } else if (g < _testNode.g) {
          // we've already evaluated this node, but last time we gave it a worse g value
          best_g = true;
        }

        if (best_g) {
          _testNode.g = g;

          // record the f value, which is takes into account both the cost to get here and the probable cost to get from here to the destination
          _testNode.f = g + _testNode.h;

          // record the node we travelled through to get here
          _testNode.parentNode = _currentNode;
        }
      }
    }

    // no result was found - there's no path - so we'll return an empty vector
    return [];
  };

  function getNodeWithLowestF(list) {
    var low_f_index = 0;

    for (let i = 0; i < list.length; ++i) {
      if (list[i].f < list[low_f_index].f) {
        low_f_index = i;
      }
    }

    return list[low_f_index];
  }

  function buildPath(destinationNode, startNode) {
    var path = [];
    var node = destinationNode;

    // starting with the destination node ...
    path.push(destinationNode);

    // ... walk backwards through the parents we assigned
    while (node.uid !== startNode.uid) {
      node = node.parentNode;
      path.unshift(node);
    }

    return path;
  }

  function removeFromOpenList(node) {
    for (var i = 0; i < _openList.length; ++i) {
      if (node === _openList[i]) {
        _openList.splice(i, 1);
      }
    }
  }

  function isOnOpenList(node) {
    for (var i = 0; i < _openList.length; ++i) {
      if (node.uid === _openList[i].uid) {
        return true;
      }
    }
    return false;
  }

  function isOnClosedList(node) {
    for (var i = 0; i < _closedList.length; ++i) {
      if (node.uid === _closedList[i].uid) {
        return true;
      }
    }
    return false;
  }
};
module.exports = AStarSearch;
